export default __webpack_public_path__ + "static/media/hn.cba64dd3.svg";